import React from "react";

const DeleteAccount = ({ handleDeleteAccount }) => {
    return (
        <div className="account-section">

            <div className="account-row">
                <p>Delete Account</p>

                <button
                    className="delete-btn"
                    onClick={handleDeleteAccount}
                >
                    Delete
                </button>
            </div>

        </div>
    );
};

export default DeleteAccount;